/* eslint-disable react/no-danger */
import PropTypes from 'prop-types';
import Head from 'next/head';

const Yoast = ({ seo }) => (
  <Head>
    <title>{seo.title}</title>
    <meta name="description" content={seo.metaDesc} />
    <meta
      name="robots"
      content={`${seo.metaRobotsNoindex}, ${seo.metaRobotsNofollow}`}
    />
    <meta
      name="googlebot"
      content={`${seo.metaRobotsNoindex}, ${seo.metaRobotsNofollow}, max-snippet:-1, max-image-preview:large, max-video-preview:-1`}
    />
    <meta
      name="bingbot"
      content={`${seo.metaRobotsNoindex}, ${seo.metaRobotsNofollow}, max-snippet:-1, max-image-preview:large, max-video-preview:-1`}
    />

    <meta property="og:type" content={seo.opengraphType} />
    <meta property="og:title" content={seo.opengraphTitle} key="ogTitle" />
    <meta property="og:description" content={seo.opengraphDescription} />
    <meta
      property="article:published_time"
      content={seo.opengraphPublishedTime}
    />
    <meta
      property="article:modified_time"
      content={seo.opengraphModifiedTime}
    />
    <meta
      property="og:image"
      content={
        seo.opengraphImage?.sourceUrl ||
        'https://www.yesware.com/blog/media/open-graph.png'
      }
    />
    <meta property="og:locale" content="en_US" />
    <meta property="og:site_name" content={seo.opengraphSiteName} />
    <meta property="article:publisher" content={seo.opengraphPublisher} />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:creator" content="@yesware" />
    <meta name="twitter:site" content="@yesware" />
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: seo.schema.raw,
      }}
    />
  </Head>
);

Yoast.propTypes = {
  seo: PropTypes.shape({
    title: PropTypes.string.isRequired,
    metaDesc: PropTypes.string.isRequired,
    metaRobotsNoindex: PropTypes.string.isRequired,
    metaRobotsNofollow: PropTypes.string.isRequired,
    opengraphType: PropTypes.string.isRequired,
    opengraphTitle: PropTypes.string.isRequired,
    opengraphDescription: PropTypes.string.isRequired,
    opengraphPublishedTime: PropTypes.string.isRequired,
    opengraphModifiedTime: PropTypes.string.isRequired,
    opengraphImage: PropTypes.shape({
      sourceUrl: PropTypes.string,
    }).isRequired,
    opengraphSiteName: PropTypes.string.isRequired,
    opengraphPublisher: PropTypes.string.isRequired,
    schema: PropTypes.shape({
      raw: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Yoast;
